import {
    ADD_GANG_MEMBER,
    DELETE_GANG_MEMBER,
    SET_GANG_MEMBER_UPDATE_MESSAGE,
    SUBMIT_GANG_MEMBER_SIGNATURE,
    EightPointChecklistTabActionTypes,
    SUBMIT_GANG_MEMBER_ABSENCE,
    DELETE_GANG_MEMBER_SIGNATURE,
} from "./types";
import { Permit } from "../../models/Permit";
import { PermitState } from "../PermitContainer/types";

const reducer = (state: PermitState, action: EightPointChecklistTabActionTypes) => {
    switch (action.type) {
        case ADD_GANG_MEMBER:
            return {
                ...state,
                permit: {
                    ...state.permit,
                    permitGangMembers: [
                        ...(state.permit ? state.permit.permitGangMembers : []),
                        { ...action.permitGangMember, pendingSync: true },
                    ],
                    pendingSave: true,
                } as Permit,
                permitGangMemberUpdateMessage: "",
            };
        case DELETE_GANG_MEMBER:
            return {
                ...state,
                permit: {
                    ...state.permit,
                    permitGangMembers: state.permit?.permitGangMembers.map((m) =>
                        m.id === action.permitGangMember.id && !m.deleted
                            ? {
                                  ...m,
                                  pendingDelete: true,
                              }
                            : { ...m }
                    ),
                    pendingSave: true,
                } as Permit,
                permitGangMemberUpdateMessage: "",
            };
        case SET_GANG_MEMBER_UPDATE_MESSAGE:
            return {
                ...state,
                permitGangMemberUpdateMessage: action.message,
            };
        case SUBMIT_GANG_MEMBER_SIGNATURE:
            return {
                ...state,
                permit: {
                    ...state.permit,
                    permitGangMembers: state.permit?.permitGangMembers.map((m) =>
                        m.id === action.permitGangMemberId
                            ? {
                                  ...m,
                                  signatures: [
                                      ...m.signatures,
                                      {
                                          ...action.signature,
                                          pendingSync: true,
                                      },
                                  ],
                              }
                            : { ...m }
                    ),
                    pendingSave: true,
                } as Permit,
                newFiles: [...state.newFiles, action.signatureFile],
                permitGangMemberUpdateMessage: "",
            };
        case SUBMIT_GANG_MEMBER_ABSENCE:
            return {
                ...state,
                permit: {
                    ...state.permit,
                    permitGangMembers: state.permit?.permitGangMembers.map((m) =>
                        m.id === action.permitGangMemberId
                            ? {
                                  ...m,
                                  signatures: [
                                      ...m.signatures,
                                      {
                                          ...action.absenceSignature,
                                          pendingSync: true,
                                      },
                                  ],
                              }
                            : { ...m }
                    ),
                    pendingSave: true,
                } as Permit,
                permitGangMemberUpdateMessage: "",
            };
        case DELETE_GANG_MEMBER_SIGNATURE:
            return {
                ...state,
                permit: {
                    ...state.permit,
                    permitGangMembers: state.permit?.permitGangMembers.map((m) =>
                        m.id === action.permitGangMemberId && !m.deleted
                            ? {
                                  ...m,
                                  signatures: m.signatures.map((s) =>
                                      s.id === action.signatureId && !s.deleted
                                          ? { ...s, pendingDelete: true }
                                          : { ...s }
                                  ),
                              }
                            : { ...m }
                    ),
                    pendingSave: true,
                } as Permit,
                permitGangMemberUpdateMessage: "",
            };

        default:
            return state;
    }
};

export default reducer;
